import {useEffect} from "react";
import {useTitle} from "../../contexts/title";

export default function ForbiddenPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Forbidden')
	}, [pageTitle]);

	return (<>
		<div className={'content-block'}>
			<h2>Access Forbidden</h2>
		</div>
	</>)
}
